/**
 * The two languages the app speaks. Everything else in this package is keyed
 * by one of these; nothing in the game rules ever is.
 */

export const LOCALES = ["id", "en"] as const;

export type Locale = (typeof LOCALES)[number];

/** Bahasa Indonesia first: that is who the product is for. */
export const DEFAULT_LOCALE: Locale = "id";

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

/** The name of a language, written in that language. */
export const LOCALE_NAME: Record<Locale, string> = {
  id: "Bahasa Indonesia",
  en: "English",
};

/** Two-letter switch label, e.g. for the header selector. */
export const LOCALE_SHORT: Record<Locale, string> = {
  id: "ID",
  en: "EN",
};
